module.exports = __webpack_public_path__ + "img/white.63eed2cf.png";